import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { CATEGORIES, essaysByCategory } from '../data/essays';
import EssayCardGraphic from '../components/EssayCardGraphic';

const DataEssays = () => {
  return (
    <Layout>
      <div className="hero-modern hero-name">
        <div className="container">
          <div className="hero-content-modern">
            <h1 className="hero-name-title">Data Essays</h1>
          </div>
        </div>
      </div>

      <div className="features-section">
        <div className="container">
          {CATEGORIES.map((category) => (
            <section key={category.id} className="essay-group">
              <h2 className="essay-group-title">{category.title}</h2>

              <div className="features-grid essays-grid">
                {essaysByCategory(category.id).map((essay) => (
                  <Link
                    key={essay.slug}
                    to={`/data-essays/${essay.slug}`}
                    className={`feature-card ${essay.accent}`}
                  >
                    {/* Figure and title only. What each one is, is the picture's
                        job; what kind of thing it is, the group heading already
                        said. `subtitle` is still carried in the data for the essay
                        pages, it is just not printed here. */}
                    {essay.graphic && <EssayCardGraphic kind={essay.graphic} />}
                    <h3>{essay.title}</h3>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default DataEssays;
